/// CPF e CNPJ conferidos pelos próprios dígitos verificadores.
///
/// Mora nos contratos porque mais de um módulo cadastra gente com documento — cliente e fornecedor — e
/// módulo não importa módulo. Copiar a conta faria duas versões dela envelhecerem separadas.

export function digitsOf(value: string | null | undefined): string | null {
  const normalized = (value ?? '').replace(/\D/gu, '');
  return normalized || null;
}

export function isValidCpf(value: string): boolean {
  if (!/^\d{11}$/u.test(value) || /^(\d)\1+$/u.test(value)) return false;
  const digit = (length: number): number => {
    let sum = 0;
    for (let index = 0; index < length; index += 1) {
      sum += Number(value[index]) * (length + 1 - index);
    }
    const remainder = (sum * 10) % 11;
    return remainder === 10 ? 0 : remainder;
  };
  return digit(9) === Number(value[9]) && digit(10) === Number(value[10]);
}

export function isValidCnpj(value: string): boolean {
  if (!/^\d{14}$/u.test(value) || /^(\d)\1+$/u.test(value)) return false;
  const calculate = (length: number): number => {
    const weights =
      length === 12
        ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
        : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const sum = weights.reduce((total, weight, index) => total + Number(value[index]) * weight, 0);
    const remainder = sum % 11;
    return remainder < 2 ? 0 : 11 - remainder;
  };
  return calculate(12) === Number(value[12]) && calculate(13) === Number(value[13]);
}
